/**
 * App-layer API del bounded context Inventory.
 * Aplicación + store + helpers inline. Sin UI, sin re-export de stock.
 * public-api.ts re-exporta este archivo junto con stock/public-api y UI directa.
 */

export {
  notifyStockDataChanged,
} from './store/index';

export {
  getEffectiveStockSalePolicy,
  resolveEffectiveStockSalePolicy,
} from './application/effectiveStockSalePolicy';
